import React from "react"; // Remove useState if not used locally
import { Modal, Button, Form } from "react-bootstrap";
import { FaSave, FaTimes } from "react-icons/fa";
import OtpInput from "./OtpInput"; // Import the OtpInput component

const ChangePasswordModal = ({
  show,
  onHide,
  onSave,
  onRequestOtp, // Function to call parent's OTP request logic
  otp,
  setOtp,
  newPassword,
  setNewPassword,
  otpRequested, // Flag from parent indicating if OTP step is active
  setOtpRequested, // Function to update parent's otpRequested state if needed by internal logic
  otpSuccessMessage, // Flag from parent indicating OTP sent successfully
}) => {
  // Remove local lastOtpRequest state, parent handles cooldown

  const handleRequestOtpClick = () => {
    // Call the parent's OTP request function, specifying the type
    onRequestOtp("password");
  };

  const handleRequestNewOtp = () => {
    setOtpRequested(false); // Signal parent to reset OTP state for a new request
    // Parent's handlePasswordChange or handleOtpRequest should handle resetting OTP fields etc.
    // Optionally, call onRequestOtp again immediately, or let user click the main button
    // For now, just reset the state, user clicks "Request OTP" again.
  };

  const handleCancel = () => {
    // Let the parent handle state reset on hide
    onHide();
  };

  const handleSaveClick = () => {
    onSave(); // Call the save handler passed from parent
  };

  // Disable save if OTP isn't 6 digits or password is too short
  const isSaveDisabled = otp.join("").length !== 6 || newPassword.length < 8;

  return (
    // Prevent closing on backdrop click or Esc when OTP is requested for better UX
    <Modal show={show} onHide={handleCancel} centered backdrop={otpRequested ? "static" : true} keyboard={!otpRequested}>
      {/* Hide close button during OTP entry */}
      <Modal.Header closeButton={!otpRequested}>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!otpRequested ? (
          // Initial view: Prompt to request OTP
          <div>
            <p>
              To change your password, we need to verify your identity.
              Click below to send a One-Time Password (OTP) to your registered email.
            </p>
            {/* Buttons moved to footer */}
          </div>
        ) : (
          // OTP view: Show OTP input and new password field
          <Form onSubmit={(e) => { e.preventDefault(); if (!isSaveDisabled) handleSaveClick(); }}> {/* Allow submitting with Enter */}
            {otpSuccessMessage && (
              <p className="text-success text-center mb-3">
                OTP sent successfully. Please check your email and enter it below.
              </p>
            )}
            <OtpInput
              otp={otp}
              setOtp={setOtp}
              onResendOtp={handleRequestNewOtp} // Pass the function to allow requesting new OTP from within OtpInput
            />
            <Form.Group controlId="formNewPasswordInput">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password (min 8 characters)"
                required
                minLength={8}
                autoFocus // Focus password field after OTP entry
              />
               <Form.Text className="text-muted">
                 Minimum 8 characters required.
               </Form.Text>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
       <Modal.Footer className="d-flex justify-content-between"> {/* Added flex justify */}
        {!otpRequested ? (
            // Initial state: Show Cancel and Request OTP buttons
            <>
                <Button variant="outline-secondary" onClick={handleCancel}> {/* Changed variant */}
                    <FaTimes className="me-1" /> Cancel
                </Button>
                <Button variant="primary" onClick={handleRequestOtpClick}>
                    Request OTP
                </Button>
            </>
        ) : (
            // OTP Requested state: Show Cancel and Save buttons
            <>
                <Button variant="outline-secondary" onClick={handleCancel}> {/* Changed variant */}
                    <FaTimes className="me-1" /> Cancel
                </Button>
                <Button variant="primary" onClick={handleSaveClick} disabled={isSaveDisabled}>
                    <FaSave className="me-1" /> Save Password
                </Button>
            </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;
